/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'menu': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M1 7.02A2 2 0 0 1 3 5h42a2 2 0 0 1 2 2.02 2 2 0 0 1-2 2.02H3a2 2 0 0 1-2-2.02zM1 40.98a2 2 0 0 1 2-2.02h42a2 2 0 0 1 2 2.02A2 2 0 0 1 45 43H3a2 2 0 0 1-2-2.02zM1 24a2 2 0 0 1 2-2.02h42A2 2 0 0 1 47 24a2 2 0 0 1-2 2.02H3A2 2 0 0 1 1 24z"/>'
  }
})
